import { useState } from "react";
import axios from "axios";
import { Crown } from "lucide-react";
import { toast } from "sonner";
import { API, errText, num } from "@/components/bulk/common";
import { ContactPicker } from "@/components/bulk/ContactPicker";

export const VIP = "VIP Müşteriler";

export function VipEditor({ groups, onSaved }) {
  const [initial, setInitial] = useState(null), [busy, setBusy] = useState(false);
  const n = groups.find((g) => g.name === VIP)?.active || 0;
  const open = () => axios.get(`${API}/bulk/contacts/ids`, { params: { group: VIP, status: "active" } }).then((r) => setInitial(r.data.ids)).catch(() => toast.error("VIP listesi yüklenemedi"));
  const done = async (phones) => {
    const before = new Set(initial), after = new Set(phones);
    const add = phones.filter((p) => !before.has(p)), remove = initial.filter((p) => !after.has(p));
    setBusy(true);
    try {
      if (add.length) await axios.post(`${API}/bulk/contacts/groups`, { group: VIP, phones: add, action: "add" });
      if (remove.length) await axios.post(`${API}/bulk/contacts/groups`, { group: VIP, phones: remove, action: "remove" });
      toast.success(`${VIP} listesinde ${num(phones.length)} kişi var`); setInitial(null); onSaved(phones.length);
    } catch (e) { toast.error(errText(e)); }
    setBusy(false);
  };
  return (
    <>
      <button type="button" className="outline-btn" disabled={busy} onClick={open} data-testid="audience-vip-edit"><Crown size={14} />{n ? `VIP listesini düzenle (${num(n)} kişi)` : "VIP listesine kişi ekle"}</button>
      {initial && <ContactPicker initial={initial} groups={groups} title={`${VIP} listesi`} onClose={() => setInitial(null)} onDone={done} />}
    </>
  );
}
